<template>
  <div>
    <template v-if="$federation.countryCode == 'FI'">
      <div
        v-if="fees.registrationFeeTotalCents"
        data-test="registrationFeeTotal"
        :class="{ 'currency-display': noWhiteSpaceWrap }"
      >
        {{ $t("events:shared.competitionFees.registrationFeeTotal.label") }}
        <span class="currency-display bold text-accent">
          {{ masterCurrency(fees.registrationFeeTotalCents) }}

          <span
            v-if="
              entryPricesGiven &&
              comp.registrationFeeTotalCents !=
                entryPrices.registrationFeeTotalCents
            "
            style="font-size: 16px"
            >*</span
          >
        </span>
        <template
          v-if="
            !entryPricesGiven && fees.useDiscountedRegistrationFeeForClubMembers
          "
        >
          ({{ masterCurrency(fees.discountedRegistrationFeeTotalCents) }})
        </template>
      </div>
      <div
        v-if="fees.startingFeeToOrganiserCents"
        data-test="startingFeeToOrganiser"
        :class="{ 'currency-display': noWhiteSpaceWrap }"
      >
        {{ $t("events:shared.competitionFees.startingFeeToOrganiser.label") }}
        <span :class="{ 'currency-display': noWhiteSpaceWrap }">
          {{ masterCurrency(fees.startingFeeToOrganiserCents) }}
          <span
            v-if="
              entryPricesGiven &&
              comp.startingFeeToOrganiserCents !=
                entryPrices.startingFeeToOrganiserCents
            "
            style="font-size: 16px"
            >*</span
          >
        </span>
        <template
          v-if="
            !entryPricesGiven && fees.useDiscountedStartingFeeForClubMembers
          "
        >
          ({{ masterCurrency(fees.discountedStartingFeeCents) }})
        </template>
      </div>
      <div
        v-if="fees.cupFeeToFederationCents"
        data-test="cupFeeToFederation"
        :class="{ 'currency-display': noWhiteSpaceWrap }"
      >
        {{ $t("events:shared.competitionFees.cupFeeToFederation.label") }}
        <span :class="{ 'currency-display': noWhiteSpaceWrap }">
          {{ masterCurrency(fees.cupFeeToFederationCents) }}
        </span>
      </div>

      <div
        v-if="fees.lateRegistrationFeeCents"
        data-test="lateRegistrationFee"
        :class="{ 'currency-display': noWhiteSpaceWrap }"
      >
        {{ $t("events:shared.competitionFees.lateRegistrationFee.label") }}
        <span :class="{ 'currency-display': noWhiteSpaceWrap }">
          {{ masterCurrency(fees.lateRegistrationFeeCents) }}
        </span>
      </div>
    </template>
    <template v-else-if="$federation.countryCode == 'NO'">
      <div
        v-if="fees.registrationFeeToOrganiserCents"
        data-test="registrationFeeToOrganiser"
        :class="{ 'currency-display': noWhiteSpaceWrap }"
      >
        {{
          $t("events:shared.competitionFees.registrationFeeToOrganiser.label")
        }}
        <span :class="{ 'currency-display': noWhiteSpaceWrap }">
          {{ masterCurrency(fees.registrationFeeToOrganiserCents) }}
          <span
            v-if="
              entryPricesGiven &&
              comp.registrationFeeToOrganiserCents !=
                entryPrices.registrationFeeToOrganiserCents
            "
            style="font-size: 16px"
            >*</span
          >
        </span>
        <template
          v-if="
            !entryPricesGiven && fees.useDiscountedRegistrationFeeForClubMembers
          "
        >
          ({{ masterCurrency(fees.discountedRegistrationFeeCents) }})
        </template>
      </div>
      <div
        v-if="fees.startingFeeToOrganiserCents"
        data-test="startingFeeToOrganiser"
        :class="{ 'currency-display': noWhiteSpaceWrap }"
      >
        {{ $t("events:shared.competitionFees.startingFeeToOrganiser.label") }}
        <span :class="{ 'currency-display': noWhiteSpaceWrap }">
          {{ masterCurrency(fees.startingFeeToOrganiserCents) }}
          <span
            v-if="
              entryPricesGiven &&
              comp.startingFeeToOrganiserCents !=
                entryPrices.startingFeeToOrganiserCents
            "
            style="font-size: 16px"
            >*</span
          >
        </span>
        <template
          v-if="
            !entryPricesGiven && fees.useDiscountedStartingFeeForClubMembers
          "
        >
          ({{ masterCurrency(fees.discountedStartingFeeCents) }})
        </template>
      </div>

      <div
        v-if="fees.startingFeeNonOrganiserTotalCents"
        data-test="startingFeeNonOrganiserTotal"
        :class="{ 'currency-display': noWhiteSpaceWrap }"
      >
        {{
          $t("events:shared.competitionFees.startingFeeNonOrganiserTotal.label")
        }}
        <span :class="{ 'currency-display': noWhiteSpaceWrap }">
          {{ masterCurrency(fees.startingFeeNonOrganiserTotalCents) }}
        </span>
      </div>

      <div
        v-if="fees.registrationFeeNonOrganiserTotalCents"
        data-test="registrationFeeNonOrganiserTotal"
        :class="{ 'currency-display': noWhiteSpaceWrap }"
      >
        {{
          $t(
            "events:shared.competitionFees.registrationFeeNonOrganiserTotal.label"
          )
        }}
        <span :class="{ 'currency-display': noWhiteSpaceWrap }">
          {{ masterCurrency(fees.registrationFeeNonOrganiserTotalCents) }}
        </span>
      </div>

      <div
        v-if="fees.totalFeesCents"
        :class="{ 'currency-display': noWhiteSpaceWrap }"
        data-test="totalFees"
      >
        {{ $t("events:shared.competitionFees.totalFees.label") }}
        <span class="accent-text bold currency-display">
          {{ masterCurrency(fees.totalFeesCents) }}
          <template
            v-if="
              (!entryPricesGiven &&
                fees.useDiscountedRegistrationFeeForClubMembers) ||
              fees.useDiscountedStartingFeeForClubMembers
            "
          >
            ({{ masterCurrency(fees.discountedTotalFeesCents) }})
          </template>
        </span>
      </div>

      <div v-if="fees.lateRegistrationFeeCents" data-test="lateRegistrationFee">
        {{ $t("events:shared.competitionFees.lateRegistrationFee.label") }}
        <span :class="{ 'currency-display': noWhiteSpaceWrap }">
          {{ masterCurrency(fees.lateRegistrationFeeCents) }}
        </span>
      </div>
    </template>
    <template v-else-if="$federation.countryCode == 'BE'">
      <div
        v-if="fees.totalFeesCents"
        :class="{ 'currency-display': noWhiteSpaceWrap }"
        data-test="totalFees"
      >
        {{ $t("events:shared.competitionFees.totalFees.label") }}
        <span class="accent-text bold currency-display">
          {{ masterCurrency(fees.totalFeesCents) }}
          <template
            v-if="
              (!entryPricesGiven &&
                fees.useDiscountedRegistrationFeeForClubMembers) ||
              fees.useDiscountedStartingFeeForClubMembers
            "
          >
            ({{ masterCurrency(fees.discountedTotalFeesCents) }})
          </template>
        </span>
      </div>

      <div v-if="fees.lateRegistrationFeeCents" data-test="lateRegistrationFee">
        {{ $t("events:shared.competitionFees.lateRegistrationFee.label") }}
        <span :class="{ 'currency-display': noWhiteSpaceWrap }">
          {{ masterCurrency(fees.lateRegistrationFeeCents) }}
        </span>
      </div>
    </template>
    <template v-else-if="$federation == 'NL'">
      <div
        v-if="fees.registrationFeeTotalCents"
        data-test="registrationFeeTotal"
        :class="{ 'currency-display': noWhiteSpaceWrap }"
      >
        {{ $t("events:shared.competitionFees.registrationFeeTotal.label") }}
        <span class="currency-display bold text-accent">
          {{ masterCurrency(fees.registrationFeeTotalCents) }}

          <span
            v-if="
              entryPricesGiven &&
              comp.registrationFeeTotalCents !=
                entryPrices.registrationFeeTotalCents
            "
            style="font-size: 16px"
            >*</span
          >
        </span>
        <template
          v-if="
            !entryPricesGiven && fees.useDiscountedRegistrationFeeForClubMembers
          "
        >
          ({{ masterCurrency(fees.discountedRegistrationFeeTotalCents) }})
        </template>
      </div>
      <div
        v-if="fees.startingFeeToOrganiserCents"
        data-test="startingFeeToOrganiser"
        :class="{ 'currency-display': noWhiteSpaceWrap }"
      >
        {{ $t("events:shared.competitionFees.startingFeeToOrganiser.label") }}
        <span :class="{ 'currency-display': noWhiteSpaceWrap }">
          {{ masterCurrency(fees.startingFeeToOrganiserCents) }}
          <span
            v-if="
              entryPricesGiven &&
              comp.startingFeeToOrganiserCents !=
                entryPrices.startingFeeToOrganiserCents
            "
            style="font-size: 16px"
            >*</span
          >
        </span>
        <template
          v-if="
            !entryPricesGiven && fees.useDiscountedStartingFeeForClubMembers
          "
        >
          ({{ masterCurrency(fees.discountedStartingFeeCents) }})
        </template>
      </div>
      <div
        v-if="fees.cupFeeToFederationCents"
        data-test="cupFeeToFederation"
        :class="{ 'currency-display': noWhiteSpaceWrap }"
      >
        {{ $t("events:shared.competitionFees.cupFeeToFederation.label") }}
        <span :class="{ 'currency-display': noWhiteSpaceWrap }">
          {{ masterCurrency(fees.cupFeeToFederationCents) }}
        </span>
      </div>

      <div
        v-if="fees.lateRegistrationFeeCents"
        data-test="lateRegistrationFee"
        :class="{ 'currency-display': noWhiteSpaceWrap }"
      >
        {{ $t("events:shared.competitionFees.lateRegistrationFee.label") }}
        <span :class="{ 'currency-display': noWhiteSpaceWrap }">
          {{ masterCurrency(fees.lateRegistrationFeeCents) }}
        </span>
      </div>
    </template>

    <small v-if="discountApplied" class="text-left">
      {{
        $t(
          "events:RegistrationForm.fees.discounts.secondarytext",
          "*Club discount applied"
        )
      }}
    </small>
    <div>
      <AppChip v-if="comp.paidExternally" color="edit-green" small>
        {{ $t("common:paidInShowOffice.badge", "Paid in show office") }}
      </AppChip>
    </div>
  </div>
</template>
<script>
import gql from "fraql";
import { useCurrency } from "@composables/masterdata/config";
import AppChip from "@elements/AppChip.vue";

export const COMPETITION_FEES_GQL = gql`
  fragment _ on Competition {
    registrationFeeTotalCents
    cupFeeToFederationCents

    registrationFeeToOrganiserCents
    useDiscountedRegistrationFeeForClubMembers
    discountedRegistrationFeeCents
    discountedRegistrationFeeTotalCents

    startingFeeToOrganiserCents
    useDiscountedStartingFeeForClubMembers
    discountedStartingFeeCents

    startingFeeNonOrganiserTotalCents
    registrationFeeNonOrganiserTotalCents

    totalFeesCents
    discountedTotalFeesCents

    lateRegistrationFeeCents

    paidExternally
  }
`;

export const COMPETITION_FEES_DISCOUNTABLE_GQL = gql`
  fragment _ on Competition {
    registrationFeeTotalCents
    startingFeeToOrganiserCents
    registrationFeeToOrganiserCents

    paidExternally
  }
`;

export default {
  name: "AppShowCompetitionFees",
  components: { AppChip },
  props: {
    comp: {
      type: Object,
      required: true
    },
    entryPrices: {
      type: Object,
      default: () => ({})
    },
    noWhiteSpaceWrap: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    return {
      ...useCurrency()
    };
  },
  computed: {
    entryPricesGiven() {
      return Object.keys(this.entryPrices).length > 0;
    },
    fees() {
      // Clone and mix into together
      return Object.assign(
        JSON.parse(JSON.stringify(this.comp)),
        JSON.parse(JSON.stringify(this.entryPrices))
      );
    },
    discountApplied() {
      if (!this.entryPricesGiven) return false;
      switch (this.$federation.countryCode) {
        case "NO":
          return (
            this.feeHasDiscount(
              this.comp.startingFeeToOrganiserCents,
              this.entryPrices.startingFeeToOrganiserCents
            ) ||
            this.feeHasDiscount(
              this.comp.registrationFeeToOrganiserCents,
              this.entryPrices.registrationFeeToOrganiserCents
            )
          );
        case "FI":
        case "NL":
          return (
            this.feeHasDiscount(
              this.comp.registrationFeeTotalCents,
              this.entryPrices.registrationFeeTotalCents
            ) ||
            this.feeHasDiscount(
              this.comp.startingFeeToOrganiserCents,
              this.entryPrices.startingFeeToOrganiserCents
            )
          );
        default:
          return false;
      }
    }
  },
  methods: {
    feeHasDiscount(original, target) {
      // Turn paremeter to number, check that is not NaN and its truthy or equal to 0
      const targetPrice =
        !Number.isNaN(Number(target)) && (target || target == 0);
      const originalPrice =
        !Number.isNaN(Number(original)) && (original || original == 0);

      return targetPrice && originalPrice ? target != original : false;
    }
  },
  fragments: {
    competitionFees: COMPETITION_FEES_GQL,
    competitionFeesDiscountable: COMPETITION_FEES_DISCOUNTABLE_GQL
  }
};
</script>
